import Header from "../layout/header";

function OnboardingObjectPage() {
  return (
    <div className="main">
      <Header />
      <div
        style={{
          padding: "clamp(16px, 3vw, 24px) clamp(12px, 3vw, 24px)",
          maxWidth: "100%",
          boxSizing: "border-box",
          minHeight: "calc(100vh - 80px)",
          background: "linear-gradient(135deg, #1e2127 0%, #2a2d35 100%)"
        }}
      >
        <div
          style={{
            backgroundColor: "#20232b",
            border: "1px solid #3a3f4b",
            borderRadius: "10px",
            padding: "20px",
            color: "#fff",
            maxWidth: "min(700px, 100%)"
          }}
        >
          <h1 style={{ marginTop: 0 }}>Onboarding Objects</h1>
          <p style={{ color: "#9ca3af", marginBottom: 0 }}>
            This screen is ready. Add onboarding objects functionality here.
          </p>
        </div>
      </div>
    </div>
  );
}

export default OnboardingObjectPage;
